/* global localStorage */
import axios from "axios";
import { API_HOST, editBillingURL, endpoints, newTokenURL, recaptchaGoogle, subscriptionRenewURL } from "./config";
// const environment = process.env.NODE_ENV;
/**
 * Function that creates a standardized Axios request handler
 * with all the required headers and parameters
 *
 * @returns axios request
 */
function getClient() {
  const token = localStorage.getItem("dfp/session");
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const client = axios.create({
    // baseURL: API_HOST,
    baseURL: API_HOST,
    validateStatus: false,
    headers,
  });
  return client;
}


export function newGetClient() {
  const newToken = localStorage.getItem("dfp/TokenSearch");
  const headers = {};
  if (newToken) {
    headers.Authorization = `Bearer ${newToken}`;
  }
  const client = axios.create({
    baseURL: API_HOST,
    validateStatus: false,
    headers,
  });
  return client;
}

/**
 * Post edit billing
 */
export async function postEditBilling(userData) {
  const res = await axios.post(editBillingURL, userData);
  return res;
}
/**
 * Post New Token
 */
export async function postNewToken(email) {
  const res = await axios.post(newTokenURL, email);
  return res;
}

/**
 * Login endpoint, it requires user data,
 * an email and a password
 * @param {Object} userData { email, password }
 */
export async function authorize(userData) {
  const res = await getClient().post(endpoints.auth, userData);
  return res;
}
/**
 * OAuth connector consent endpoint. Verifies email+password (same check as
 * /auth) and, on success, returns { redirect_url } pointing back at the
 * OAuth client (e.g. claude.ai) with a one-time authorization code.
 * @param {Object} payload { email, password, client_id, redirect_uri, code_challenge, state, scope }
 */
export async function authorizeOAuthConsent(payload) {
  const res = await getClient().post(endpoints.oauthConsent, payload);
  return res;
}
/**
 * Initiate Password Reset for the email provided
 * @param {String} email
 */
export async function sendPasswordReset(email) {
  const res = await getClient().post(endpoints.sendResetPasswordEmail, email);
  return res;
}

/**
 * Resets the user's password for new provided value
 * @param {String} token API generated, obtained from url string query parameters
 * @param {String} password user new set password
 */
export async function resetPassword(token, password) {
  const res = await getClient().put(
    `${endpoints.resetPassword}/${token}`,
    password
  );
  return res;
}
/**
 * Sends an email to the user with a link to verify the user's email
 * @param {String} email user provided email
 */
export async function sendEmailVerification(email) {
  const res = await getClient().post(endpoints.signup, { email });
  return res;
}

export async function validateRecaptcha(token) {
  // recaptchaGoogle already contains the full URL (env-specific)
  return axios.post(recaptchaGoogle, { token });
}

/**
 * Validate the Plan
 */
export async function ValidatePlan(plan_id) {
  const res = await getClient().get(`${endpoints.ValidatePlan}/${plan_id}`);
  return res;
}
export async function getPlan() {
  const res = await getClient().get(endpoints.getPlan);
  return res;
}
export async function getViews() {
  const res = await getClient().get(`${endpoints.views}?page=1&limit=50`);
  return res;
}
export async function getDefaultViews() {
  const res = await getClient().get(endpoints.defaultViews);
  return res;
}

/**
 * Create logged in user's account information
 */
export async function createAccount(jwt, userData) {
  const res = await getClient().post(`${endpoints.signup}/${jwt}`, userData);
  return res;
}

/**
 * Get logged in user's account information
 */
export async function getAccount() {
  const res = await getClient().get(endpoints.account);
  return res;
}
/** 
  SEARCHES
**/

// BUSINESS DATA
export async function postBusiness(queryData) {
  queryData.view = "business_preview";
  const res = await getClient().post(endpoints.businessData, queryData);
  return res;
}

export async function postBusinessNewImplementation(page, queryData) {
  queryData.view = "business_preview";
  const res = await newGetClient().post(
    `${endpoints.businessDataPaginated}?page=${page}&limit=50`,
    queryData
  );
  return res;
}

// PEOPLE DATA
export async function postPeople(queryData) {
  queryData.view = "people_preview";
  const res = await getClient().post(endpoints.people, queryData);
  return res;
}

export async function postPeoplePaginatedNewImplementation(page, queryData) {
  queryData.view = "people_preview";
  const res = await newGetClient().post(
    `${endpoints.peoplePaginate}?page=${page}&limit=50`,
    queryData
  );
  return res;
}

// In your API functions file
export async function postPeopleByKey(peopleKey) {
  // Construct the query with the provided people_key
  const queryData = {
    query: `keys:"${peopleKey}"`,
    view: "people_preview"
  };

  // Send the post request using your getClient instance
  const res = await getClient().post(endpoints.people, queryData);
  return res;
}


// PRODUCT DATA

export async function postProduct(queryData) {
  queryData.view = "product_preview";
  const res = await getClient().post(endpoints.product, queryData);
  return res;
}

export async function postProductPaginatedDR(page, queryData) {
  queryData.view = "product_preview";
  const res = await newGetClient().post(
    `${endpoints.productPaginate}?page=${page}&limit=50`,
    queryData
  );
  return res;
}

// PROPERTY DATA
// export async function postProperty(queryData) {
//   queryData.view = "property_sourceURLs";
//   const res = await getClient().post(endpoints.propertyData, queryData);
//   return res;
// }

export async function postProperty(queryData) {
  // clone to avoid side‑effects
  const data = { ...queryData };
  // fall back to the default only if caller didn’t supply one
  if (!data.view) {
    data.view = 'property_sourceURLs';
  }

  const res = await getClient().post(endpoints.propertyData, data);
  return res;
}


export async function postPropertyPaginatedDr6(page, queryData) {
  queryData.view = "property_preview";
  const res = await newGetClient().post(
    `${endpoints.propertyDataPaginate}?page=${page}&limit=50`,
    queryData
  );
  return res;
}


/**
 * get downloads
 */
export async function getDownloads(page, limit) {
  const res = await getClient().get(
    `${endpoints.downloads}?page=${page}&limit=${limit}&sort[date_started]=desc`
  );
  return res;
}
/**
 * get downloads by ID
 */
export async function getDownloadsById(id) {
  const res = await getClient().get(`${endpoints.downloads}/${id}`);
  return res;
}
/**
 * update the account of the user
 */
export async function updateAccount(queryData) {
  const res = await getClient().put(endpoints.updateAccount, queryData);
  return res;
}
/**
 * update the account of the user
 */
export async function updateAccountPlan(planState) {
  const res = await getClient().put(endpoints.updateAccountPlan, planState);
  return res;
}
/**
 * update the billing plan(stripe token) of the user
 */
export async function updateBillingPlan(token) {
  const res = await getClient().put(endpoints.updateAccountPlan, token);
  return res;
}

/**
 * Get postman collection
 */
export async function getPostman() {
  const res = await getClient().get(endpoints.postman);
  return res;
}

export async function getSubscriptionRenewDate(customerId) {
  const res = await axios.get(`${subscriptionRenewURL}/${customerId}`);
  return res;
}

